import { login, getCodeImg, register, getInfo } from '@/api/login';
import { listClasses } from '@/api/OmdClasses/classes'
import { setToseck } from '@/utils/toseck';
import { validateCaptchaAPI } from '@/api/login';
import { listMajors } from '@/api/OmdMajors/majors';



export default {
  data() {
    return {
      dialogFormVisible: false,
      form: {
        username: "",
        password: "",
        rememberMe: false,
        code: "",
        uuid: ""
      },
      classList: [],
      deptList: [],
      // 专业选项数据
      majorOptions: [],

      registerForm: {
        username: "",
        password: "",
        confirmPassword: "",
        NAME: "", //学生姓名
        birthDate: "",//出生年
        studentid: "", //学号
        card: "", //身份证
        classId: "",
        tel: "",//手机号
        address: "",//家庭住址
        deptId: "101",//学校(这里不能改，101是武汉欧曼谛学校)
        code: "",
        uuid: "",
        avatar: "https://oumandi.oss-cn-beijing.aliyuncs.com/2025/07/21/学生头像_20250721221423A001.png",
        sex: "",
        majorId: "",
      },
      field101Options: [{
        "label": "男",
        "value": 0
      }, {
        "label": "女",
        "value": 1
      }],
      captchaEnabled: true,
      registcha: true,
      codeUrl: '',
      p: true,
      errorMessage: '',// 新增错误提示变量
      rules: {
        username: [
          { required: true, trigger: "blur", message: "请输入您的账号" },
          { min: 1, max: 20, message: '用户账号长度必须介于 1 和 20 之间', trigger: 'blur' }
        ],
        password: [
          { required: true, trigger: "blur", message: "请输入您的密码" },
          { min: 5, max: 20, message: "用户密码长度必须介于 5和 20 之间", trigger: "blur" },
          { pattern: /^[^<>"'|\\]+$/, message: "不能包含非法字符：< > \" ' \\ |", trigger: "blur" }

        ],
        confirmPassword: [
          { required: true, trigger: "blur", message: "请再次输入您的密码" },
          {
            validator: (rule, value, callback) => {
              if (value !== this.registerForm.password) {
                callback(new Error("两次输入密码不一致!"));
              } else {
                // 验证通过，调用 callback()
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        NAME: [
          { required: true, trigger: "blur", message: "请输入您的真实姓名" },
          { min: 1, max: 5, message: '真实姓名长度必须介于 1 和 5 之间', trigger: 'blur' }
        ],
        gender: [
          { required: true, message: '请选择性别', trigger: 'change' }
        ],
        birthDate: [
          {
            required: true,
            message: '请选择出生日期',
            trigger: 'change'
          }
        ],
        // studentid: [
        //   { required: true, trigger: "blur", message: "请输入您的学号" }
        // ],
        card: [
          { required: true, trigger: "blur", message: "请输入您的身份证号" },
          { min: 18, max: 18, message: '身份证号长度必须为 18 位', trigger: 'blur' }
        ],
        tel: [
          { required: true, trigger: "blur", message: "请输入您的手机号" },
          { min: 11, max: 11, message: '请输入正确的 11 位手机号', trigger: 'blur' }
        ],
        address: [
          { required: true, trigger: "blur", message: "请输入您的家庭住址" },
          { min: 2, max: 50, message: '家庭住址最小 2字，最大 50 字', trigger: 'blur' }
        ],
        classId: [
          { required: true, trigger: "blur", message: "请选择班级" },
        ],
        // deptId: [
        //   { required: true, trigger: "blur", message: "请选择学校" },
        // ],
        majorId: [
          { required: true, trigger: "blur", message: "请选择专业" },
        ],
        code: [
          { required: true, trigger: "change", message: "请输入验证码" }
        ]
      },

    };
  },
  created() {

    // 清除localStorage中残留的过期Token（根据你的Token存储键名调整，如"token"或"toseck"）
    localStorage.removeItem("token");
    localStorage.removeItem("toseck"); // 若你的Token存在"toseck"键下，也清除

    sessionStorage.removeItem("identity");
    sessionStorage.removeItem("user");
    console.log("已清除残留的旧Token");
    this.getCode();
    this.getMajorList();
    this.getList();
    // this.getDeptList();


  },
  mounted() {
    window.addEventListener('keydown', this.keyDown);
  },
  destroyed() {
    window.removeEventListener('keydown', this.keyDown);
  },
  methods: {

    keyDown(e) {
      if (e.keyCode === 13) {
        this.handleLogin(this.form);
      }
    },
    clearError() {
      this.errorMessage = '';
    },
    // 验证码验证
    validateCaptcha() {
      if (!this.form.code) return;

      validateCaptchaAPI(this.form.code, this.form.uuid).catch(err => {
        this.errorMessage = '验证码错误';
        this.getCode();
        console.log(err);
      });
    },
    // // 获取验证码
    getCode() {
      getCodeImg().then(res => {
        this.codeUrl = "data:image/gif;base64," + res.img;
        this.form.uuid = res.uuid;
        this.registerForm.uuid = res.uuid;
      }).catch(() => {
        this.errorMessage = '获取验证码失败';
      });
    },
    /**
    * 获取专业列表
    * @return {void}
    */
    getMajorList() {
      listMajors()
        .then(response => {
          this.majorOptions = response.rows;
        })
        .catch(error => {
          console.error("获取专业列表失败:", error);
        });
    },

    //获取班级列表
    getList() {
      listClasses(this.queryParams).then(response => {
        this.classList = response.rows;
        console.log(this.classList);

      });
    },


    // 登录方法
    handleLogin() {
      this.$refs.form.validate(valid => {
        if (!valid) {
          this.errorMessage = '请填写完整登录信息';
          this.getCode();
          return;
        }

        this.loading = true;
        this.errorMessage = '';

        // 先验证验证码
        validateCaptchaAPI(this.form.code, this.form.uuid)
          .then(() => {
            // 验证码通过后登录
            return login(this.form);
          })
          .then(res => {
            if (res.code !== 200) {
              throw new Error(res.msg || '登录失败');
            }

            setToseck(res.token);

            // 获取用户信息
            return getInfo().then(infoRes => {
              if (infoRes.code !== 200) {
                throw new Error(infoRes.msg || '获取用户信息失败');
              }
              console.log(infoRes);
              console.log("专业id",infoRes.user.majorId);

              // 存储用户信息
              
              sessionStorage.setItem('identity', infoRes.roles[0]);
              this.$store.commit('setIdentity', infoRes.roles[0]);
              sessionStorage.setItem('user', infoRes.user.userId);

              this.$router.push('/index');
            });
          })
          .catch(err => {
            this.errorMessage = err.message || '登录失败，请稍后重试';
            this.getCode();
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    //注册方法
    handleRegister() {
      console.log(this.registerForm);
      this.$refs.registerForm.validate(valid => {
        if (valid) {
          register(this.registerForm).then(res => {
            console.log("注册信息");
            console.log(res);
            if (res.code === 200) {
              this.$message({
                message: '注册成功,请登录',
                type: 'success'
              });
              this.registerForm = [];
              this.dialogFormVisible = false;
            } else {
              this.$message({
                message: res.msg,
                type: 'error'
              });
            }
          });
        } else {
          this.$message.error('请完善信息');
        }
      })
    }
  },
};
